import angular from 'angular';
import { NsjRoutingType } from '../../core/nsj-core';
import { LoadParams } from '../../shared/models/loadparams.model';
import {
    ICriadoresDeSolicitacoesListItem,
    ICriadoresDeSolicitacoesConstructor,
    ICriadoresDeSolicitacoesOffset
} from './models/criadores-de-solicitacoes.model';

export class CriadoresDeSolicitacoesService {

    static $inject = ['$rootScope', '$http', '$q', 'nsjRouting'];

    public entities: ICriadoresDeSolicitacoesListItem[] = [];
    public loaded = false;
    public constructors: ICriadoresDeSolicitacoesConstructor = {};
    public after: ICriadoresDeSolicitacoesOffset = {};
    public loadParams = new LoadParams();
    public loading_deferred: angular.IDeferred<unknown>;
    public filter = '';

    constructor(
        public $rootScope: angular.IRootScopeService,
        public $http: angular.IHttpService,
        public $q: angular.IQService,
        public nsjRouting: NsjRoutingType,
    ) { }

    reload() {
        if (this.loading_deferred) {
            this.loading_deferred.resolve();
        }

        this.after = {};
        this.loaded = false;
        this.entities = [];
        this.loadParams = new LoadParams();

        return this.load();
    }

    loadMore() {
        this.loadParams.to_load = 3;
        this.load();
    }

    _load(constructors: ICriadoresDeSolicitacoesConstructor, offset: ICriadoresDeSolicitacoesOffset, filter: string) {
        this.loading_deferred = this.$q.defer();

        return this.$q<ICriadoresDeSolicitacoesListItem[]>((resolve, reject) => {
            this.$http.get<ICriadoresDeSolicitacoesListItem[]>(
                this.nsjRouting.generate('meurh_solicitacoescriadores_index',
                    angular.extend({}, constructors, {
                        'offset': offset,
                        'filter': filter
                    }),
                true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
        });
    }

    /**
     * Retorna os usuários criadores de solicitações, com 20 itens por página
     */
    load() {
        if (!this.loadParams.busy && !this.loadParams.finished && this.loadParams.to_load > 0) {
            this.loadParams.busy = true;

            this._load(this.constructors, this.after, this.filter)
                .then((data) => {
                    if (data.length > 0) {
                        for (let i = 0; i < data.length; i++) {
                            this.entities.push(data[i]);
                        }
                        this.after = { email: this.entities[this.entities.length - 1]['ordem'] };
                    }

                    this.loaded = true;
                    this.loadParams.to_load--;

                    if (data.length < 20) {
                        this.loadParams.finished = true;
                        this.$rootScope.$broadcast('meurh_solicitacoescriadores_index_finished', this.entities);
                        return;
                    }

                    this.loadParams.finished = false;

                    if (this.loadParams.to_load === 0) {
                        this.$rootScope.$broadcast('meurh_solicitacoescriadores_index_loaded', this.entities);
                    }
                })
                .catch((error) => {
                    if (error.xhrStatus !== 'abort') {
                        this.loadParams.finished = true;
                    }
                })
                .finally(() => {
                    if (this.loaded || this.loadParams.finished) {
                        this.loadParams.busy = false;
                    }
                    this.load();
                });
        }

        return this.entities;
    }

}

angular.module('main').service('CriadoresDeSolicitacoesService', CriadoresDeSolicitacoesService);
